import { IconProps } from "@chakra-ui/react";

export function BINIcon({ ...rest }: IconProps) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_416_814)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill="#7A8F9A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill="#5B6971"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill="white"
        />
        <path
          d="M15.61 39C15.214 39 14.908 38.898 14.692 38.694C14.488 38.478 14.386 38.172 14.386 37.776V27.534C14.386 27.138 14.488 26.838 14.692 26.634C14.908 26.418 15.214 26.31 15.61 26.31H19.93C20.818 26.31 21.574 26.442 22.198 26.706C22.822 26.97 23.296 27.348 23.62 27.84C23.956 28.332 24.124 28.92 24.124 29.604C24.124 30.372 23.902 31.02 23.458 31.548C23.014 32.076 22.408 32.43 21.64 32.61V32.34C22.528 32.472 23.218 32.808 23.71 33.348C24.202 33.888 24.448 34.59 24.448 35.454C24.448 36.582 24.064 37.458 23.296 38.082C22.54 38.694 21.484 39 20.128 39H15.61ZM16.6 37.254H19.84C20.656 37.254 21.256 37.098 21.64 36.786C22.024 36.462 22.216 35.982 22.216 35.346C22.216 34.698 22.024 34.218 21.64 33.906C21.256 33.594 20.656 33.438 19.84 33.438H16.6V37.254ZM16.6 31.692H19.534C20.326 31.692 20.914 31.542 21.298 31.242C21.694 30.93 21.892 30.474 21.892 29.874C21.892 29.274 21.694 28.824 21.298 28.524C20.914 28.212 20.326 28.056 19.534 28.056H16.6V31.692ZM27.9306 39.144C27.5586 39.144 27.2706 39.042 27.0666 38.838C26.8746 38.622 26.7786 38.328 26.7786 37.956V27.354C26.7786 26.97 26.8746 26.676 27.0666 26.472C27.2706 26.268 27.5586 26.166 27.9306 26.166C28.3026 26.166 28.5846 26.268 28.7766 26.472C28.9806 26.676 29.0826 26.97 29.0826 27.354V37.956C29.0826 38.328 28.9866 38.622 28.7946 38.838C28.6026 39.042 28.3146 39.144 27.9306 39.144ZM32.9387 39.144C32.5907 39.144 32.3207 39.048 32.1287 38.856C31.9487 38.664 31.8587 38.388 31.8587 38.028V27.318C31.8587 26.946 31.9487 26.664 32.1287 26.472C32.3207 26.268 32.5667 26.166 32.8667 26.166C33.1427 26.166 33.3467 26.22 33.4787 26.328C33.6227 26.424 33.7907 26.592 33.9827 26.832L40.8767 35.778H40.4087V27.264C40.4087 26.916 40.4987 26.646 40.6787 26.454C40.8707 26.262 41.1407 26.166 41.4887 26.166C41.8367 26.166 42.1007 26.262 42.2807 26.454C42.4607 26.646 42.5507 26.916 42.5507 27.264V38.064C42.5507 38.4 42.4667 38.664 42.2987 38.856C42.1307 39.048 41.9027 39.144 41.6147 39.144C41.3387 39.144 41.1167 39.09 40.9487 38.982C40.7927 38.874 40.6187 38.7 40.4267 38.46L33.5507 29.514H34.0007V38.028C34.0007 38.388 33.9107 38.664 33.7307 38.856C33.5507 39.048 33.2867 39.144 32.9387 39.144Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_416_814">
          <rect width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
